@if (image) {
<img
  class="image"
  [src]="image.resource | ImageUrl : image.provider : { width: 64, height: 64, fileType: ImageFileTypes.WEBP }"
  [alt]="alt" />
} @else { @if (category) {
{{ image }}
<div class="image placeholder">
  <mat-icon class="placeholder--icon">{{ category.placeholderIcon }}</mat-icon>
</div>
} }
